import React, { useEffect } from 'react';

import css from './ProgressBar.module.scss';

type ProgressBarProps = {
    percentage: number;
    isObjectiveCompleted: boolean;
    isSolidarity?: boolean;
};

const ProgressBar = ({ percentage, isObjectiveCompleted, isSolidarity }: ProgressBarProps) => {
    useEffect(() => {
        const root = document.documentElement;
        root.style.setProperty('--percentage', percentage + '%');
    }, [percentage]);

    const fillerStyle = {
        width: `${percentage}%`,
        background: !isObjectiveCompleted ? '#E22B76' : '#2BE283',
    };

    const fillerSolidarityStyle = {
        width: `${percentage}%`,
        background: 'linear-gradient(to right, #EE7BAA, #E22B76)',
    };

    return (
        <div className={`${css.progress_bar}`}>
            <div
                className={`${css.filler} ${!isSolidarity ? css.animate : ''}`}
                style={!isSolidarity ? fillerStyle : fillerSolidarityStyle}
            />
        </div>
    );
};

export default ProgressBar;
